var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bannerPropById.id)?_c('adv-master',{staticClass:"banner-container",attrs:{"bannerProp":_vm.bannerPropById,"env":_vm.env,"systemCode":_vm.systemCode},on:{"onEvent":_vm.handleAdvEvent}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }